import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBagIcon } from 'lucide-react';
import { usePrototype } from '../../contexts/PrototypeContext';
export function BagButton() {
  const {
    quantity
  } = usePrototype();
  return <Link to="/cart" aria-label={`Skincare Cart, ${quantity} ${quantity === 1 ? 'item' : 'items'}`} className="relative inline-flex h-11 min-w-[44px] items-center justify-center gap-2 rounded-[3px] px-2 text-ink transition-colors duration-150 ease-out hover:text-bronze-deep" data-id="element-456" data-mp="zsgdv6439p1l">
      <ShoppingBagIcon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-457" data-mp="vsxtcbg6jfza" />
      <span className="hidden text-[14px] font-medium sm:inline" data-id="element-458" data-mp="h3tbivdardrp">Skincare Cart</span>
      {quantity > 0 && <span aria-hidden="true" className="inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-ink px-1.5 text-[11px] font-semibold text-canvas" data-id="element-459" data-mp="m236b4v40ccs">
          {quantity}
        </span>}
    </Link>;
}